export default __webpack_public_path__ + "static/media/admin.64e3ea2b.gif";